import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/uni-assets/svgs/check-big.svg'


const _withScopeId = n => (_pushScopeId("data-v-bc521a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "tw-w-[68px] tw-h-[68px]"
}, null, -1))
const _hoisted_3 = { class: "custom_input_field" }
const _hoisted_4 = { class: "custom_input_field" }
const _hoisted_5 = { class: "custom_input_field" }
const _hoisted_6 = { class: "custom_input_field tw-pb-6 tw-rounded-none tw-border-[#C5D2F2] tw-border-0 tw-border-b tw-border-solid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-max-w-[90%] tw-m-auto"
}
const _hoisted_9 = {
  key: 0,
  class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
}

import GeneralDialog from "@/core/uni-components/GeneralDialog.vue";
import Button from "@/core/uni-components/Button.vue";
import Text from "@/core/uni-components/Text.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ref } from "vue";
import { JOBS_STORE } from "@/store/modules/jobs";
import { useStore } from "vuex";
import { computed } from "vue";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import { onMounted } from "vue";
import { WORKSTATION } from "@/store/modules/workstation";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteVisitRequestDialog',
  props: {
  projectId: Number,
  projectEstimateId: Number,
},
  emits: ["on-close"],
  setup(__props, { emit: __emit }) {

const stepper = ref(0);
const store = useStore();
const emits = __emit;

const selectedProperty = ref(null);
const selectedDate = ref("");
const selectedTime = ref("");
const message = ref("");
const timeError = ref(false);
const onClickBackButton = () => {
  selectedDate.value = "";
  selectedProperty.value = null;
  message.value = "";
  timeError.value = true;
  stepper.value--;
};
const siteVisitRequests = ref([]);
const siteId = ref(null);
const onCloseModal = () => {
  emits("on-close");
};

const props = __props;
const updateTimeValidation = (value) => {
  if (!value) timeError.value = true;
  else timeError.value = false;
};
const currentJobDetails = computed(
  () => store.getters[`${JOBS_STORE}/getJobDetails`]
);

const propertyList = computed(() => {
  return currentJobDetails.value.projectProperties.map(
    (property: any) => property.property
  );
});
const formValid = ref(false);

const onSubmit = async () => {
  const formData = {
    id: siteId.value ? parseInt(siteId.value) : null,
    property: selectedProperty.value,
    date: selectedDate.value,
    startTime: JSON.stringify(selectedTime.value),
    description: message.value,
  };

  if (!selectedTime.value) {
    timeError.value = true;
    return;
  } else {
    timeError.value = false;
  }

  console.log("wenttt hereeee to request", formData);

  if (!timeError.value && formValid.value) {
    stepper.value++;

    if (props.projectEstimateId && props.projectId) {
      try {
        await store.dispatch(`${JOB_TEMPLATE_STORE}/setSiteRequest`, {
          projectEstimateId: props.projectEstimateId,
          projectId: props.projectId,
          formData,
        });
      } catch (error) {
        console.log();
      }
    }
  }
};
const selectSiteProperty = (value: any) => {
  const isExistRequest = siteVisitRequests.value.find(
    (request: any) => request.property?.id === value
  );

  if (isExistRequest) {
    siteId.value = isExistRequest?.id;
    selectedDate.value = isExistRequest?.date;
    selectedTime.value = JSON.parse(isExistRequest?.startTime);
    message.value = isExistRequest?.description;
  } else {
    selectedDate.value = "";
    selectedTime.value = "";
    message.value = "";
    siteId.value = null;
  }
};

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

onMounted(async () => {
  siteVisitRequests.value = await store.dispatch(
    `${JOB_TEMPLATE_STORE}/getSiteRequestAll`,
    {
      projectId: props.projectId,
      wsID: activeUserWorkstation?.value?.id,
    }
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: _normalizeClass(["request_visit_site_modal", {
      '!tw-w-[460px] tw-max-w-full': stepper.value === 0,
      '!tw-w-[570px] !tw-max-w-full md:tw-w-[340px] tw-rounded-[20px] ':
        stepper.value === 1,
      '!tw-w-[460px] !tw-max-w-[90%] md:tw-w-[340px] tw-rounded-[20px] tw-m-auto':
        stepper.value === 2,
    }]),
    onOnClose: onCloseModal,
    showBackButton: stepper.value === 1,
    onOnBack: onClickBackButton
  }, {
    body: _withCtx(() => [
      (stepper.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(Text, {
              variant: "h4",
              textAlign: "center",
              lineHeight: "28px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Your Site Visit Request has been " + _toDisplayString(siteId.value ? "edit request" : "submit request"), 1)
              ]),
              _: 1
            }),
            _createVNode(Text, {
              class: "tw-max-w-[80%] tw-mt-6",
              variant: "h6",
              textWeight: "500",
              textColor: "rgba(12, 15, 74, 0.5)",
              textAlign: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" You’ll be notified once your request gets accepted by the property owner ")
              ]),
              _: 1
            }),
            _createVNode(Button, {
              variant: "primary",
              label: "close",
              onClick: onCloseModal
            })
          ]))
        : _createCommentVNode("", true),
      (stepper.value === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(Text, {
              variant: "h5",
              lineHeight: "28px",
              textWeight: "400"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Request Site Visit")
              ]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              ref: "form",
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValid).value = $event)),
              class: "tw-max-w-full tw-mt-6 tw-flex tw-flex-col tw-gap-6",
              onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Text, {
                    variant: "span",
                    textWeight: "400",
                    class: "tw-mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Select Property ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    class: "custom_selector",
                    modelValue: selectedProperty.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((selectedProperty).value = $event)),
                      selectSiteProperty
                    ],
                    items: propertyList.value,
                    "item-title": "address",
                    "item-value": "id",
                    "menu-props": { contentClass: 'text__selector' },
                    placeholder: "Select Property",
                    rules: [(v) => !!v || 'Property is required'],
                    required: ""
                  }, null, 8, ["modelValue", "items", "rules"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_text_field, {
                    class: "custom_selector",
                    variant: "outlined",
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
                    label: "Select Date",
                    type: "date",
                    rules: [(v) => !!v || 'Date is required'],
                    required: "",
                    min: new Date().toISOString().substr(0, 10)
                  }, null, 8, ["modelValue", "rules", "min"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(VueDatePicker), {
                    variant: "outlined",
                    class: "date_selector",
                    modelValue: selectedTime.value,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((selectedTime).value = $event)),
                      updateTimeValidation
                    ],
                    "time-picker": "",
                    range: "",
                    required: "",
                    placeholder: "Select Time",
                    "time-picker-options": { format: 'hh:mm A' }
                  }, null, 8, ["modelValue"]),
                  (timeError.value)
                    ? (_openBlock(), _createBlock(Text, {
                        key: 0,
                        variant: "span",
                        textWeight: "400",
                        class: "tw-mb-2",
                        textColor: "red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Time is required ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(Text, {
                    variant: "span",
                    textWeight: "400",
                    class: "tw-mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Message (optional) ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_textarea, {
                    modelValue: message.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((message).value = $event)),
                    placeholder: "Message",
                    required: "",
                    variant: "outlined",
                    class: "custom_selector"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(Button, {
                  class: "button button-purple-border !tw-w-1/2 md:!tw-w-full",
                  label: siteId.value ? 'edit request' : 'submit request',
                  type: "submit"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (stepper.value === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(Text, {
              variant: "h4",
              textAlign: "center",
              lineHeight: "28px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Do you want to request a site visit?")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              class: "tw-mt-6",
              variant: "h6",
              textWeight: "500",
              textColor: "rgba(12, 15, 74, 0.5)",
              textAlign: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" If you do not want to do it right now, you can always do it later. ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (stepper.value === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(Button, {
              variant: "secondary",
              label: "i'll do it later",
              onClick: onCloseModal
            }),
            _createVNode(Button, {
              variant: "primary",
              label: "yes",
              onClick: _cache[5] || (_cache[5] = () => stepper.value++)
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["showBackButton", "class"]))
}
}

})